import Vue from 'vue';
import Vuex from 'vuex';
// @ts-ignore
import { getField, updateField } from 'vuex-map-fields';
import auth from '../store/auth';
import publications from '../store/publications';
import orders from '../store/orders';
import products from '../store/products';
import webInventory from '../store/web-inventory';
import logs from '../store/logs';
import productCategories from '../store/product-categories';
import productBrands from '../store/product-brands';
import productApplications from '../store/product-applications';
import productSectors from '../store/product-sectors';
import blogPosts from '../store/blog-posts';
import files from '../store/files';
import promos from '../store/promos';
import locations from '../store/locations';
import questions from '../store/questions';
import messages from '../store/messages';
import catalogs from '../store/catalogs';
import feedbackSystem from '../store/feedback-system';
import feedbackInvoices from '../store/feedback-invoices';
import feedbackInvoicesPDV from '../store/feedback-invoicesPDV';
import bannerHomes from '../store/banner-home';
import chatbotDocuments from '../store/chatbot-documents';
import ecommerce from './ecommerce';
import brand from './brand';
import category from './category';
import surtido from '../store/surtido';
import pdv from '../store/pdv';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        publications,
        orders,
        products,
        webInventory,
        logs,
        productCategories,
        productBrands,
        productApplications,
        productSectors,
        surtido,
        blogPosts,
        files,
        promos,
        locations,
        questions,
        messages,
        catalogs,
        feedbackSystem,
        feedbackInvoices,
        feedbackInvoicesPDV,
        bannerHomes,
        ecommerce,
        chatbotDocuments,
        brand,
        category,
        pdv
    },
    getters: {
        // Add the `getField` getter to the
        // `getters` of your Vuex store instance.
        getField,
    },
    mutations: {
        // Add the `updateField` mutation to the
        // `mutations` of your Vuex store instance.
        updateField,
    },
});
